import {Component, EventEmitter, Input, NgModule, Output} from '@angular/core';

@Component({
  selector: 'sd-expansion-panel',
  standalone: true,
  template: `
    <div class="overflow-hidden rounded-lg border border-[var(--m365-border-rest,#ececf0)] bg-white">
      <ng-content select="sd-expansion-panel-header"></ng-content>
      @if (expanded) {
        <div class="px-4 py-3">
          <ng-content></ng-content>
        </div>
      }
    </div>
  `,
  host: {class: 'sd-expansion-panel sd-expansion-panel block'},
})
export class SdExpansionPanel {
  @Input() expanded = false;
  @Input() disabled = false;
  @Output() expandedChange = new EventEmitter<boolean>();
  @Output() opened = new EventEmitter<void>();
  @Output() closed = new EventEmitter<void>();

  toggle(): void {
    this.expanded = !this.expanded;
    this.expandedChange.emit(this.expanded);
    (this.expanded ? this.opened : this.closed).emit();
  }
}

@Component({
  selector: 'sd-expansion-panel-header',
  standalone: true,
  template: `
    <button type="button" class="flex w-full items-center justify-between px-4 py-3 text-left text-sm font-medium" (click)="panel.toggle()">
      <span class="flex-1"><ng-content></ng-content></span>
      <span class="material-icons text-lg">{{ panel.expanded ? 'expand_less' : 'expand_more' }}</span>
    </button>
  `,
})
export class SdExpansionPanelHeader {
  constructor(public panel: SdExpansionPanel) {}
}

@Component({
  selector: 'sd-panel-title',
  standalone: true,
  template: `<ng-content></ng-content>`,
  host: {class: 'font-medium'},
})
export class SdPanelTitle {}

@Component({
  selector: 'sd-panel-description',
  standalone: true,
  template: `<ng-content></ng-content>`,
  host: {class: 'text-sm text-[var(--m365-text-secondary,#6b6b70)]'},
})
export class SdPanelDescription {}

@Component({
  selector: 'sd-accordion',
  standalone: true,
  template: `<ng-content></ng-content>`,
  host: {class: 'block space-y-2'},
})
export class SdAccordion {
  @Input() multi = false;
}

@NgModule({
  imports: [SdExpansionPanel, SdExpansionPanelHeader, SdPanelTitle, SdPanelDescription, SdAccordion],
  exports: [SdExpansionPanel, SdExpansionPanelHeader, SdPanelTitle, SdPanelDescription, SdAccordion],
})
export class SdExpansionModule {}
